<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Equipment</div>
				<div class="formTabTableWrap_top-add">
					<v-btn
							@click="onRefreshFilters" type="button"
							depressed
							class="mainBtn mainBtn-text iconHoverRotate"
					>
						<span class="btnIco"><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Refresh filters</span>
					</v-btn>
					<v-btn
							:disabled="getPermissionAction" @click="onEquipmentPopupHandler(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add new</span>
					</v-btn>
				</div>
			</div>
			<div class="formTabTableWrap_body">
				<equipment
						v-if="equipmentFilter"
						:listItems="equipmentList"
						:filter="equipmentFilter"
						:isRefresh="isRefresh"
						:truckId="truckId"
						:getPermissionAction="getPermissionAction"
						@updateEdit="onEdit"
						@updateRemoveItem="setRemoveItem"
				></equipment>
			</div>

			<equipment-popup
					v-if="isEquipmentPopup"
					:equipments="getEquipments"
					:drivers="drivers"
					:editItem="editItem"
					@updateEquipmentList="onUpdateEquipmentList"
					@updateSearchText="onSearchText"
					@updateClose="onEquipmentPopupHandler(false)"
			></equipment-popup>

			<remove-block
					v-if="isRemove"
					@updateRemoveItem="onRemoveItem"
					@updateRemoveClose="isRemove = false"
			></remove-block>

		</div>
	</div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import Equipment from "@/components/Maintenance/Trucks/TruckForm/Equipment/Equipment";
// async components
const EquipmentPopup =
    () => import("@/components/Maintenance/Trucks/TruckForm/EquipmentPopup/EquipmentPopup");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// helpers
import getUniqId from "@/helper/getUniqId";

export default {
	name: "ThirdTab",
	components: {
		Equipment,
		EquipmentPopup,
		RemoveBlock
	},
	props: {
		truckId: Number,
		equipments: Array,
		drivers: Array,
		getPermissionAction: Boolean,
	},
	data: () => ({
		isEquipmentPopup: false,
		editItem: null,
		isRefresh: null,
		removeItem: null,
		isRemove: false
	}),
	computed: {
		...mapGetters([ 'equipmentList', 'equipmentFilter' ]),
		getEquipments: {
			get() {
				return this.equipments;
			},
			set(values) {
				this.$emit('updateEquipmentsSelectList', values);
			}
		}
	},
	methods: {
		...mapActions([ 'onEquipmentList', 'onEquipmentCreate', 'onEquipmentSelectItem', 'onEquipmentEdit', 'onEquipmentRemove' ]),
		onRefreshFilters() {
			this.isRefresh = getUniqId();
		},
		onEquipmentPopupHandler(value) {
			this.isEquipmentPopup = value;
			if (!value) this.editItem = null;
		},
		async onUpdateEquipmentList(values) {
			values.truckId = this.truckId;
			await this.onEquipmentCreate(values);
		},
		async onSearchText(name) {
			this.getEquipments = await this.onEquipmentSelectItem(name);
		},
		async onEdit(id) {
			this.editItem = await this.onEquipmentEdit(id);
			this.isEquipmentPopup = true;
		},
		async setRemoveItem(id) {
			this.removeItem = { truckId: this.truckId, id };
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onEquipmentRemove(this.removeItem);
			this.isRemove = false;
		}
	},
	mounted() {
		this.onEquipmentList(this.truckId);
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
